<template>

  <div class="proxy-container">
    <!-- 頭部 -->
    <div class="header">
      <h2 class="title">餘額充值</h2>
    </div>

    <div style="position: fixed; top: 30px; left: 30px;">
      <el-button icon="el-icon-arrow-left" @click="close" class="back-btn" plain size="small"></el-button>
    </div>

    <!-- 主要內容 -->
    <div class="content-container">
      <div style="max-width: 500px; margin: 0 auto;">
        <!-- 充值金額輸入 -->
        <div style="margin: 0 0 32px 0;">
          <div style="color: #666; font-size: 14px; margin-bottom: 12px;">充值金額 (HKD)</div>
          <div style="background: #f8f9ff; border-radius: 8px; padding: 16px; border: 1px solid #e0e4ff;">
            <el-input v-model="amount" placeholder="請輸入充值金額" type="number" style="font-size: 24px; text-align: center;"
              :style="{ color: amount ? '#3E4F7A' : '#999' }" @input="handleAmountInput">
              <template slot="suffix">HKD</template>
            </el-input>
          </div>
        </div>

        <!-- 支付方式 -->
        <div style="margin-bottom: 24px;">
          <div style="color: #666; font-size: 14px; margin-bottom: 12px;">選擇支付方式</div>

          <!-- 轉數快支付 -->
          <div style="background: #F6F8FB; border: 1px solid #E0E0E0;
               border-radius: 8px; padding: 16px; position: relative;" @click="selectPayment('fps')">
            <div style="display: flex; align-items: center; gap: 12px;">
              <div style="background: #43974E; width: 40px; height: 40px; 
                   border-radius: 8px; display: flex; align-items: center;
                   justify-content: center;">
                <span style="color: white; font-size: 20px;">$</span>
              </div>
              <div>
                <div style="font-weight: 600; color: #3E4F7A;">轉數快支付</div>
                <div style="color: #999; font-size: 12px; margin-top: 4px;">
                  10分鐘內到賬 · 推薦香港用戶使用
                </div>
              </div>
            </div>
            <div v-if="selectedPayment === 'fps'" style="position: absolute; right: 16px; top: 50%;
                    transform: translateY(-50%); color: #43974E;">
              ✓
            </div>
          </div>
        </div>

        <!-- 去支付按鈕 -->
        <button @click="handlePayment" :disabled="!isValidAmount" style="width: 100%; padding: 16px; background: #3E4F7A;
             color: white; border-radius: 8px; font-size: 16px;
             border: none; cursor: pointer; transition: opacity 0.3s;" :style="{ opacity: isValidAmount ? 1 : 0.6 }">
          立即支付 HKD {{ Number(amount).toFixed(2) || '0.00' }}
        </button>

        <!-- 新增充值訂單按鈕 -->
      <div style="margin-top: 18px;">
         <div
          class="order-btn"
          @click="$router.push({ name: 'PayOrder' })"
        >
          查看充值訂單
        </div>
      </div>

        <!-- 支付提示 -->
        <!-- <div style="margin-top: 24px; padding: 12px; background: #FEF8EB;
              border-radius: 6px; color: #ED8E34; font-size: 12px;">
          <div style="display: flex; gap: 8px;">
            <div>⚠️</div>
            <div>溫馨提示：請確保支付金額與訂單一致，轉賬時備註訂單號</div>
          </div>
        </div> -->

      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      amount: '',
      selectedPayment: 'fps', // 當前選中的支付方式
      minAmount: 1,        // 最小充值金額
      maxAmount: 9999999       // 最大充值金額
    }
  },
  computed: {
    isValidAmount() {
      const num = Number(this.amount)
      return num >= this.minAmount && num <= this.maxAmount
    }
  },
  methods: {
    handleAmountInput(value) {
      // 限制輸入範圍
      if (value > this.maxAmount) {
        this.amount = this.maxAmount
      }
    },
    selectPayment(method) {
      this.selectedPayment = method
    },
     close() {
      this.$router.go(-1);
    },
    handlePayment() {
      if (!this.isValidAmount) return

      this.$confirm(`確認支付 HKD ${Number(this.amount).toFixed(2)} ？`, '確認支付', {
        confirmButtonText: '立即支付',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 調用支付接口
        this.submitPayment()
      }).catch(() => { })
    },
    submitPayment() {
      // 這裏添加實際支付邏輯
      // console.log('發起支付請求，金額：', this.amount)
      // this.$message.success('跳轉支付頁面...')

      this.$router.push({
        name: 'FpsPay',
        query: { amount: this.amount }
      });

    }
  }
}
</script>

<style>
.proxy-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.header {
  padding: 16px 0;
  margin-bottom: 12px;
}

/* 新增訂單按鈕樣式 */
.order-btn {
  padding: 12px;
  text-align: center;
  margin-top: 24px;
  background: transparent;
  border: 1px solid #3E4F7A;
  color: #3E4F7A;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 400;
  transition: all 0.3s;
}


.title {
  text-align: center;
  color: #3E4F7A;
  margin: 0;
  font-size: 20px;
  letter-spacing: 1px;
}

.content-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* 自定義輸入框樣式 */
.el-input__inner {
  border: none !important;
  background: transparent !important;
  font-weight: 600 !important;
  padding: 0 !important;
  height: 40px !important;
}

.el-input__prefix {
  left: 10px !important;
  font-size: 16px !important;
  color: #3E4F7A !important;
}
</style>
